import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ParametrosMaestro } from 'src/app/models/common/enumModel';
import { ITipoReglaModel } from 'src/app/models/interfaces/tipo-regla/ITipoReglaModel';
import { ParametroModel } from 'src/app/models/parametros/ParametroModel';
import { TipoReglaModel } from 'src/app/models/tipo-regla/TipoReglaModel';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { ParametroService } from 'src/app/services/parametros/parametro.service';
import { TipoReglaService } from 'src/app/services/tipo-regla/tipo-regla.service';

@Component({
  selector: 'app-configuracion-regla-editar-editar',
  templateUrl: './configuracion-tipo-regla-editar.component.html',
  styleUrls: ['./configuracion-tipo-regla-editar.component.css']
})
export class ConfiguracionTipoReglaEditarComponent implements OnInit {
  id: number = 0;
  model: ITipoReglaModel = new TipoReglaModel();
  listaEstados: ParametroModel[] = new Array<ParametroModel>();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private serviceTipoRegla: TipoReglaService,
    private serviceParametros: ParametroService,
    private confirmDialogService: ConfirmDialogService,
    private alertDialogService: AlertDialogService,
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.id = params['id'];
    });

    this.serviceParametros.getDetalles(ParametrosMaestro.ESTADO_CONFIG_MAESTRO).subscribe((data) => {
      this.listaEstados = data.items;
    });

    this.serviceTipoRegla.getById(this.id).subscribe((data) => {
      this.model = data;
    });
  }

  onSubmit(form: NgForm) {
    if (!form.invalid) {   
      this.confirmDialogService.open('¿Deseas guardar los cambios?'); //options
      this.confirmDialogService.confirmed().subscribe((confirmed) => {
        if (confirmed) {
          this.serviceTipoRegla.update(this.model).subscribe((data) => {
            this.alertDialogService.open("El tipo de regla fue actualizado");
            this.router.navigate(['/configuracion', 'tipo-reglas']);  
          });
        }
      });
    }
  }
}
